import axios from '@/utils/request'
// 查询字典树
export function patrolGetDict(params) {
  const patrolGetDict = axios({
    url: '/dict/findDictTree',
    method: 'get',
    params
  })
  return patrolGetDict
}
// 新增字典
export function saveDict(data) {
  const saveDict = axios({
    url: '/dict/saveDict',
    method: 'post',
    data
  })
  return saveDict
}
// 删除字典
export function deleteDict(params) {
  const deleteDict = axios({
    url: '/dict/deleteDict',
    method: 'get',
    params
  })
  return deleteDict
}
// 编辑字典
export function updateDict(data) {
  const updateDict = axios({
    url: '/dict/updateDict',
    method: 'post',
    data
  })
  return updateDict
}
// 根据父级Code递归查询
export function findDictTreeByCodes(params) {
  const findDictTreeByCodes = axios({
    url: '/dict/findDictTreeByCodes',
    method: 'get',
    params
  })
  return findDictTreeByCodes
}
// 根据父级Code递归查询
export function buildTreeByCodes(params) {
  const buildTreeByCodes = axios({
    url: 'dict/buildTreeByCodes',
    method: 'get',
    params
  })
  return buildTreeByCodes
}
// 上移下移 -亚林
export function moveDict(params) {
  const moveDict = axios({
    url: '/dict/moveDict',
    method: 'get',
    params
  })
  return moveDict
}
// 字典用pid查询
export function selectDictListByPid(params) {
  const selectDictListByPid = axios({
    url: '/dict/selectDictListByPid',
    method: 'get',
    params
  })
  return selectDictListByPid
}
/***********************************************采集项********************/
// 采集项分页列表
export function itemPageList(params) {
  const itemPageList = axios({
    url: '/patrolSet/itemPageList',
    method: 'get',
    params
  })
  return itemPageList
}
// 采集项新增或修改
export function itemInsertOrUpdatePolling(data) {
  const itemInsertOrUpdatePolling = axios({
    url: '/patrolSet/itemInsertOrUpdate',
    method: 'post',
    data
  })
  return itemInsertOrUpdatePolling
}
// 采集项查看详情2 编辑未使用
export function itemDetails2Polling(params) {
  const itemDetails2Polling = axios({
    url: '/patrolSet/itemDetails2',
    method: 'get',
    params
  })
  return itemDetails2Polling
}
// 采集项启用停用
export function itemGeneralStatusToggle(params) {
  const itemGeneralStatusToggle = axios({
    url: '/patrolSet/itemGeneralStatusToggle',
    method: 'get',
    params
  })
  return itemGeneralStatusToggle
}
// 采集项上移下移
export function itemChangeSort(data) {
  const itemChangeSort = axios({
    url: '/patrolSet/itemChangeSort',
    method: 'post',
    data
  })
  return itemChangeSort
}
// 采集项删除
export function deleteItem(params) {
  const deleteItem = axios({
    url: '/patrolSet/deleteItem',
    method: 'get',
    params
  })
  return deleteItem
}
/**************************************采集模版******************************/
// 模板分页列表
export function templatePageList(params) {
  const templatePageList = axios({
    url: '/patrolSet/templatePageList',
    method: 'get',
    params
  })
  return templatePageList
}
// 采集项列表
export function itemListPolling(data) {
  const itemListPolling = axios({
    url: '/patrolSet/itemList',
    method: 'post',
    data
  })
  return itemListPolling
}
// 模板新增或修改
export function templateInsertOrUpdatePolling(data) {
  const templateInsertOrUpdatePolling = axios({
    url: '/patrolSet/templateInsertOrUpdate',
    method: 'post',
    data
  })
  return templateInsertOrUpdatePolling
}
// 模板查看详情
export function templateDetailsPolling(params) {
  const templateDetailsPolling = axios({
    url: '/patrolSet/templateDetails',
    method: 'get',
    params
  })
  return templateDetailsPolling
}
// 模板启用停用
export function templateGeneralStatusTogglePolling(params) {
  const templateGeneralStatusTogglePolling = axios({
    url: '/patrolSet/templateGeneralStatusToggle',
    method: 'get',
    params
  })
  return templateGeneralStatusTogglePolling
}
// 根据父级Code递归查询字典数据列表
export function dicByType(params) {
  const dicByType = axios({
    url: '/dict/selectDictListByParentCode',
    method: 'get',
    params
  })
  return dicByType
}
// 模板下拉
export function pullTemplate(params) {
  const pullTemplate = axios({
    url: '/patrolSet/pullTemplate',
    method: 'get',
    params
  })
  return pullTemplate
}
// 按照设备、事件类型获取模板下拉
export function getTemplateByType(params) {
  const getTemplateByType = axios({
    url: '/patrolSet/getTemplateByType',
    method: 'get',
    params
  })
  return getTemplateByType
}
// 采集模版删除
export function deleteTemplate(params) {
  const deleteTemplate = axios({
    url: '/patrolSet/deleteTemplate',
    method: 'get',
    params
  })
  return deleteTemplate
}
/*********************************系统配置********************************** */
// 系统配置列表
export function systemConfigList(params) {
  const systemConfigList = axios({
    url: '/patrolSet/systemConfigList',
    method: 'get',
    params
  })
  return systemConfigList
}
// 修改系统配置
export function changeSystemConfig(data) {
  const changeSystemConfig = axios({
    url: '/patrolSet/changeSystemConfig',
    method: 'post',
    data
  })
  return changeSystemConfig
}
